import React, { forwardRef, useEffect, useState } from "react";
import moment from "moment";
import { formatNumberWithCurrency } from "../../../utils/utils";
import {
  typeDiscountObj,
  paymentItemType,
  findLabelPaymentMethod,
} from "../../../utils/constants";
import styles from "./PrintInvoice.module.css";
import cx from "classnames";

const PrintInvoice = forwardRef((props, ref) => {
  const [productItems, setProductItems] = useState([]);
  const PrintContentLabel = ({ label, value, isSmall = false }) => {
    return (
      <div className="d-flex">
        <div
          className={
            isSmall ? styles.labelTitleInvoiceSmall : styles.labelTitleInvoice
          }
        >
          <p>{label}</p>
        </div>
        <div className="">
          <p>: {value || "-"}</p>
        </div>
      </div>
    );
  };

  const PrintContentCounted = ({ label, value, isSmall = false }) => {
    return (
      <div className="d-flex w-100">
        <div style={{ width: widthBlank }}></div>
        <div style={{ width: widthSubTotal }}>
          <p style={{ fontWeight: 600, fontSize: isSmall ? 12 : 14 }}>
            {label} :
          </p>
        </div>
        <div style={{ width: widthValueSubTotal }}>
          <p style={{ fontWeight: 600, fontSize: isSmall ? 12 : 14 }}>
            {formatNumberWithCurrency(value)}
          </p>
        </div>
      </div>
    );
  };

  const formatProductItems = (items) => {
    const formatted = {};

    items?.forEach((item) => {
      const categoryKey = item?.is_package
        ? "Paket"
        : item?.is_deposit
        ? "Deposit"
        : item.category_name || "Item";
      if (!formatted[categoryKey]) {
        formatted[categoryKey] = {
          nameCategory: categoryKey,
          subTotal: 0,
          products: [],
        };
      }

      // Calculate discount based on type without considering quantity
      let finalAmount = item.amount;
      if (item.type_discount === "NUMBER") {
        finalAmount -= parseFloat(item.discount);
      } else if (item.type_discount === "PERCENTAGE") {
        finalAmount -= (finalAmount * parseFloat(item.discount)) / 100;
      }

      formatted[categoryKey].subTotal += finalAmount;
      formatted[categoryKey].products.push({
        id: item.item_id,
        name:
          item.item_name_original ||
          item.item_name ||
          item.package_name ||
          item.deposit_item_name,
        qty: item.quantity,
        amount: item.amount,
        typeDiscount: item.type_discount,
        discount: item.discount,
        type: item.type,
      });
    });

    return Object.values(formatted);
  };

  useEffect(() => {
    if (
      props.dataDetailReservation &&
      (props.dataDetailReservation?.payment ||
        props?.dataDetailReservation?.payment_parent?.length > 0) &&
      productItems.length === 0
    ) {
      let formatedProductPayment = [];
      const formatedProductParentPayment = [];

      if (props?.dataDetailReservation?.payment) {
        formatedProductPayment = formatProductItems(
          props.dataDetailReservation?.payment?.payment_items?.filter(
            (item) =>
              item.type === paymentItemType.CONSULTATION ||
              item.type === paymentItemType.DEPOSIT_USED ||
              item.type === paymentItemType.CORRECTION
          )
        );
      }

      props?.dataDetailReservation?.payment_parent?.forEach((item) => {
        formatedProductParentPayment.push(
          ...formatProductItems(
            item?.payment_items?.filter(
              (item) =>
                item.type === paymentItemType.CONSULTATION ||
                item.type === paymentItemType.DEPOSIT_USED ||
                item.type === paymentItemType.CORRECTION
            )
          )
        );
      });

      setProductItems([
        ...formatedProductPayment,
        ...formatedProductParentPayment,
      ]);
    }
    // eslint-disable-next-line
  }, [props?.dataDetailReservation]);

  useEffect(() => {
    if (
      props.dataDetailReservation &&
      props?.isPaymentItem &&
      props.dataDetailReservation?.payment?.payment_items?.length > 0 &&
      productItems.length === 0
    ) {
      let formatedProductPayment = [];

      if (props?.dataDetailReservation?.payment?.payment_items) {
        formatedProductPayment = formatProductItems(
          props.dataDetailReservation?.payment?.payment_items?.filter(
            (item) => item.type === paymentItemType.FARMASI
          )
        );
      }

      setProductItems([...formatedProductPayment]);
    }
    // eslint-disable-next-line
  }, [props?.dataDetailReservation, props?.isPaymentItem]);

  const widthItemCode = "15%";
  const widthItemDescription = "55%";
  const widthItemQty = "15%";
  const widthItemValue = "15%";

  const widthBlank = "30%";
  const widthSubTotal = "40%";
  const widthValueSubTotal = "30%";

  const dataReservation = props?.dataDetailReservation;
  let totalAmount = dataReservation?.payment?.total_amount || 0;
  let totalAmountCorrection =
    dataReservation?.payment?.total_amount_correction || 0;

  const totalBalance = dataReservation?.wallet_balance || 0;
  const balanceUsed = dataReservation?.payment?.saldo || 0;
  dataReservation?.payment_parent?.forEach((parent) => {
    totalAmount += parent.total_amount;
    totalAmountCorrection += parent.total_amount_correction;
  });

  const totalAmountAfterCorrection = totalAmount + totalAmountCorrection;
  const patientName = props?.patientName || dataReservation?.name;
  const peymentMethod = findLabelPaymentMethod(
    dataReservation?.payment?.payment_method || "CASH"
  );

  return (
    <div ref={ref} className={styles.wrapperBackground}>
      <div className={styles.wrapperBody}>
        {/* <p>KOP SURAT KLINIK</p> */}
        <div className="d-flex justify-content-center">
          <p>BUKTI PEMBAYARAN</p>
        </div>
        <div>
          <div className={styles.borderItem}>
            <div className="d-flex">
              <div className={styles.wrapperContentInvoice}>
                <PrintContentLabel label="Pemjamin" value="Pribadi" />
                <PrintContentLabel
                  label="Kasir"
                  value={dataReservation?.payment?.updated_by}
                />
                <PrintContentLabel label="Metode" value={peymentMethod} />
              </div>
              <div className={styles.wrapperContentInvoice}>
                <PrintContentLabel
                  label="No. Invoice"
                  value={dataReservation?.payment?.no_invoice}
                />
                <PrintContentLabel
                  label="Tgl. Invoice"
                  value={moment(dataReservation?.payment?.created_at).format(
                    "DD MMMM YYYY, HH:mm"
                  )}
                />
              </div>
            </div>
          </div>
          <div className={styles.borderBottomItem}>
            <div className="d-flex gap-4">
              <div className={styles.wrapperContentInvoice}>
                <PrintContentLabel label="Nama Pasien" value={patientName} />
                <PrintContentLabel
                  label="Tgl. Konsultasi"
                  value={dataReservation?.reservationDate}
                />
              </div>
              <div className={styles.wrapperContentInvoice}>
                <PrintContentLabel
                  label="No. Rekam Medis"
                  value={props?.noRm}
                />
                <PrintContentLabel
                  label="Tgl. Lahir"
                  value={dataReservation?.dateOfBirth}
                />
                {totalBalance > 0 && (
                  <PrintContentLabel
                    label="Sisa Saldo"
                    value={formatNumberWithCurrency(totalBalance)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="section-item">
          <div className={styles.borderItem}>
            <div className="d-flex title-item">
              <p style={{ width: widthItemDescription }}>Keterangan</p>
              <p style={{ width: widthItemQty }}>Jumlah</p>
              <p style={{ width: widthItemValue }}>Nilai</p>
              <p style={{ width: widthItemCode }}>Discount</p>
            </div>
          </div>
          <div>
            {productItems.map((item, categoryIndex) => (
              <div className={styles.wrapperItemCategory} key={categoryIndex}>
                {item.products
                  .sort((a, b) => {
                    const aItemId = a.id || 0;
                    const bItemId = b.id || 0;

                    if (aItemId !== bItemId) {
                      return aItemId - bItemId;
                    }

                    const typeOrder = {
                      [paymentItemType.CONSULTATION]: 1,
                      [paymentItemType.CORRECTION]: 2,
                      [paymentItemType.DEPOSIT_USED]: 3,
                    };

                    const aOrder = typeOrder[a.type] || 4;
                    const bOrder = typeOrder[b.type] || 4;

                    return aOrder - bOrder;
                  })
                  .map((product, index) => (
                    <div className="d-flex" key={index}>
                      <div
                        className="product-item"
                        style={{ width: widthItemDescription }}
                      >
                        <p>
                          {product.name}{" "}
                          {product.type === paymentItemType.CORRECTION &&
                            "(Koreksi)"}
                        </p>
                      </div>
                      <div
                        className={styles.contentItem}
                        style={{ width: widthItemQty }}
                      >
                        <p>{product.qty}</p>
                      </div>
                      <div
                        className={styles.contentItem}
                        style={{ width: widthItemValue }}
                      >
                        <p>
                          {product.amount &&
                            formatNumberWithCurrency(product.amount)}
                        </p>
                      </div>
                      <div
                        className={styles.contentItem}
                        style={{ width: widthItemCode }}
                      >
                        <p>
                          {product.typeDiscount === typeDiscountObj.NUMBER
                            ? formatNumberWithCurrency(product.discount)
                            : product.discount
                            ? `${product.discount}%`
                            : ""}
                        </p>
                      </div>
                    </div>
                  ))}
                <div className={styles.borderBottomItem}>
                  <PrintContentCounted
                    label="Sub Total"
                    value={item.subTotal}
                  />
                </div>
              </div>
            ))}
          </div>
          <div className={cx("d-flex flex-column", styles.borderBottomItem)}>
            {balanceUsed > 0 && (
              <>
                <PrintContentCounted
                  label="Sub Total"
                  value={balanceUsed + totalAmount}
                  isSmall
                />
                <PrintContentCounted
                  label="Saldo digunakan"
                  value={-balanceUsed}
                  isSmall
                />
              </>
            )}
            <PrintContentCounted
              label="Total Biaya (Sebelum Koreksi)"
              value={totalAmount || 0}
            />
            <PrintContentCounted
              label="Total Biaya Koreksi"
              value={totalAmountCorrection || 0}
            />
            <PrintContentCounted
              label="Total Biaya"
              value={totalAmountAfterCorrection || 0}
            />
          </div>
        </div>
        <ul className={styles.userAggrement}>
          <li>
            Barang yang sudah dibeli tidak dapat ditukar atau dikembalikan
          </li>
          <li>Harga sudah termasuk PPN</li>
        </ul>
      </div>
    </div>
  );
});

export default PrintInvoice;
